import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SmallBanner from '../components/smallBanner';
import { ReactComponent as CallIcon } from '../assets/icons/call-icon.svg';
import { ReactComponent as EmailIcon } from '../assets/icons/email-icon.svg';
import { ReactComponent as MapIcon } from '../assets/icons/map.svg';
import axios from "axios";
import { BASE_URL, GET_CONTACTLIST, POST_Contact } from "../ApiUrl";
import FeedbackPopup from "../components/FeedbackPopup";

const Contact = () => {

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: '',
    });

    const [errors, setErrors] = useState({
        email: '',
        phone: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });

        if (name === 'email') {
            validateEmail(value);
        }

        if (name === 'phone') {
            validatePhone(value);
        }
    };

    const validateEmail = (email) => {
        // Regex to check if email is in correct format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email.match(emailRegex)) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                email: 'Please enter a valid email address.',
            }));
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                email: '',
            }));
        }
    };

    const validatePhone = (phone) => {
        const phoneRegex = /^\d{10}$/;// Regex for India phone number with +91
        if (!phone.match(phoneRegex)) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                phone: 'Phone number must start with  10 digits.',
            }));
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                phone: '',
            }));
        }
    };

    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        // console.log('Form Data:', formData);

        try {
            const result = await axios.post(BASE_URL + POST_Contact, formData);
            // console.log('Result:', result.data.message);
            setPopupMessage(result.data.message);
            setShowPopup(true);
            setFormData({
                name: '',
                phone: '',
                email: '',
                message: '',
            });
        } catch (error) {
            if (error.response && error.response.status === 400) {
                setPopupMessage('There was an issue with your submission. Please check your input and try again.');
            } else {
                setPopupMessage('Something went wrong. Please try again later.');
            }
            setShowPopup(true);
        }
    };

    const [contactlist, setcontactlist] = useState();

    const handlecontactlist = async () => {
        try {
            const result = await axios.get(BASE_URL + GET_CONTACTLIST);
            setcontactlist(result.data.contactlist);
        } catch (error) {
            console.error('Error fetching blogs:', error);
        }
    };

    // console.log(contactlist, "contactlistcontactlist");


    useEffect(() => {
        handlecontactlist();
    }, []);

    useEffect(() => {
        if (showPopup) {
            const timer = setTimeout(() => {
                setShowPopup(false); // Hide the popup after 20 seconds
            }, 5000); // 20 seconds in milliseconds

            return () => clearTimeout(timer); // Cleanup the timer if the component is unmounted
        }
    }, [showPopup]);

    return (
        <main className="contact-page">
            {showPopup && <FeedbackPopup message={popupMessage} />} {/* Conditionally show FeedbackPopup */}
            <SmallBanner Heading={'Let’s Connect & Grow Together!'} />
            <section className="contact-wrapper">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-lg-6 col-md-6 col-12 mb-3">
                                        <input type="text" className="form-control" id="exampleFormControlInputname" placeholder="Your Name" name="name" value={formData.name} onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-12 mb-3">
                                        <input type="tel" className="form-control" id="exampleFormControlInputphoneno" placeholder="Phone Number" name="phone" value={formData.phone} onChange={handleChange}
                                        />
                                        {errors.phone && <div className="text-danger">{errors.phone}</div>}
                                    </div>
                                    <div className="col-12 mb-3">
                                        <input type="email" className="form-control" id="exampleFormControlInputEmail" placeholder="Your Email Address" name="email" value={formData.email} onChange={handleChange}
                                        />
                                        {errors.email && <div className="text-danger">{errors.email}</div>}
                                    </div>
                                    <div className="col-12 mb-3">
                                        <textarea name="message" className="form-control" placeholder="Drop a Message" rows="3" value={formData.message} onChange={handleChange}
                                        />
                                    </div>
                                </div>
                                <button type="submit" className="btn-grad d-inline-flex align-items-center justify-content-center text-uppercase border border-0">
                                    Submit
                                </button>
                            </form>
                            <div>
                                <iframe
                                    src="https://www.google.com/maps?q=Avna+Private+Limited&output=embed"
                                    width="100%"
                                    height="340"
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                    title="Google Map"
                                    className='fotter-map mt-3'
                                ></iframe>
                            </div>
                        </div>
                        <div className="col-lg-5">
                            <div className="card" data-aos="fade-left" data-aos-duration="3000">
                                <div className="row">
                                    {
                                        contactlist?.map((value, index) => {
                                            return (
                                                <div className="col-12 icon-box" key={index}>
                                                    <div className="icon-wrapper">
                                                        <EmailIcon />
                                                    </div>
                                                    <div>
                                                        <h4 className="title-text">Contact Us</h4>
                                                        {/* <Link href="mailto:info@avnain.com" className="link">info@avnain.com</Link> */}
                                                        <Link to={`mailto:${value.email}`} className="link">{value.email}</Link>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }

                                    {
                                        contactlist?.map((value, index) => {
                                            return (
                                                <div className="col-12 icon-box" key={index}>
                                                    <div className="icon-wrapper">
                                                        <CallIcon />
                                                    </div>
                                                    <div>
                                                        <h4 className="title-text">Call Us</h4>
                                                        {/* <Link href="tel:+8000041402" className="link">+91 8000041402</Link> */}
                                                        <Link to={`tel:+91${value.phone}`} className="link">+91 {value.phone}</Link>
                                                    </div>
                                                </div>
                                            );

                                        })
                                    }

                                    {
                                        contactlist?.map((value, index) => {
                                            return (
                                                <div className="col-12 icon-box" key={index}>
                                                    <div className="icon-wrapper">
                                                        <MapIcon />
                                                    </div>
                                                    <div>
                                                        <h4 className="title-text">Locations</h4>
                                                        {/* <Link href="https://www.google.com/maps/search/s.one+complex,+b-417,+circle,+near+Gujarat+high+court,+Shayona+City,+Chanakyapuri,+Ahmedabad,+Gujarat+380061/@23.079098,72.531832,13z?hl=en-US&entry=ttu&g_ep=EgoyMDI1MDExNS4wIKXMDSoASAFQAw%3D%3D" target='_blank' className="link mb-0">s.one complex, b-417, circle, near Gujarat high court, Shayona City, Chanakyapuri, Ahmedabad, Gujarat 380061.</Link> */}
                                                        <Link to={`https://www.google.com/maps/search/${encodeURIComponent(value.locations)}`} target="_blank" className="link mb-0">{value.locations}</Link>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                    <div className="col-12 icon-box">
                                        <div className="icon-wrapper">
                                            <MapIcon />
                                        </div>
                                        <div>
                                            <h4 className="title-text">Manufacturing Unit</h4>
                                            <Link className="link mb-0">UNIT No. 110, Akshar Industrial Park, Sector-2, Opposite Sarkhej Bavla National Highway, Ahmedabad- 382213, Gujarat, India</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Contact;